import React from 'react';
import { Flex, Box, AccordionButton, AccordionItem, AccordionIcon, AccordionPanel, Text } from '@chakra-ui/react';
import { cssVariables } from '../../../redux/cssVariablesSlice';
import { useSelector, useDispatch } from 'react-redux';
import CssEditorColorPicker from './CssEditorColorPicker';

const editableVar = ['--text-color-1'];

const CssEditorTextColors = () => {
	const cssVar = useSelector(cssVariables);

	if (!cssVar) return null;

	return (
		<AccordionItem>
			<AccordionButton justifyContent={'space-between'}>
				<Text>Cores de Texto</Text>
				<AccordionIcon />
			</AccordionButton>
			<AccordionPanel>
				<Box p={2} maxH={'400px'} overflow={'visible'}>
					<Flex flexDir="column" sx={{ gap: '1px' }} overflow={'visible'}>
						{Object.keys(cssVar)
							.map((varName, index) => {
								if (editableVar.find((el) => el == varName)) {
									return <CssEditorColorPicker key={'CEColorPicker-' + index} {...{ varName, cssVar }} />;
								}
							})
							.filter((el) => el)}
					</Flex>
				</Box>
			</AccordionPanel>
		</AccordionItem>
	);
};

export default CssEditorTextColors;
